var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-extend-menu-section-contents" },
    _vm._l(_vm.noticeList, function (notice) {
      return _c("RoomChatForm", {
        key: notice.noticeId,
        attrs: {
          type: "notice",
          section: _vm.section,
          item: _vm.itemObj(notice),
          menuList: _vm.menuList(notice),
        },
        on: {
          click: function ($event) {
            return _vm.$emit("onClickItem", notice)
          },
          onClickDownload: function ($event) {
            return _vm.handleClickDownloadFile(notice)
          },
          onClickDelete: _vm.onClickDelete,
          onChangeNoticeSection: function ($event) {
            _vm.isChatSection && _vm.$emit("onChangeNoticeSection")
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }